import { Theme } from '../types';

export const theme: Theme = {
  colors: {
    // Purple/Gold color scheme matching logo (Royalty & Divine Glory)
    primary: '#6A4C93', // Purple from logo (shield)
    secondary: '#8B5FBF', // Lighter purple
    accent: '#FFB703', // Gold from logo (lightning/text)
    background: '#030019', // Exact background from logo (deep navy, almost black)
    surface: '#0a0a20', // Slightly lighter navy for cards
    text: '#FFFFFE', // Off-white
    textSecondary: '#A7A9BE', // Muted gray
    success: '#06D6A0', // Teal green
    error: '#EF476F', // Red
    warning: '#FFB703', // Gold (same as accent)
    info: '#4CC9F0', // Cyan
  },
  breakpoints: {
    mobile: '320px',
    tablet: '768px',
    desktop: '1024px',
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
  },
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '16px',
    full: '9999px',
  },
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  },
};

// Media query helpers
export const breakpoint = {
  mobile: `@media (min-width: ${theme.breakpoints.mobile})`,
  tablet: `@media (min-width: ${theme.breakpoints.tablet})`,
  desktop: `@media (min-width: ${theme.breakpoints.desktop})`,
};
